module.exports = __webpack_public_path__ + "img/logo-2.1fb3822c.png";